
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/tutorial/index",
      function () {
        return require("private-next-pages/app/tutorial/index/index.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/tutorial/index"])
      });
    }
  